import React from "react"
import { Card, Currency, InfoIconWrapper, Title, Value } from "./DataCard.styled"
import CountUp from "react-countup"
import { TooltipIcon } from "../Ui/TooltipIcon"

interface DataCardProps {
  label: string
  value: number
  currency?: string
  infoText?: string
  isInvertedComparison?: boolean
  handleOnClick?: () => void
}

export default function DataCard({
  label,
  value,
  currency,
  infoText,
  handleOnClick
}: DataCardProps) {
  return (
    <Card onClick={handleOnClick} $hasOnClick={!!handleOnClick}>
      {infoText && (
        <InfoIconWrapper>
          <TooltipIcon content={infoText} />
        </InfoIconWrapper>
      )}
      <Title>{label}</Title>
      <Value>
        <CountUp end={value} duration={1} />
        {currency && <Currency>{currency}</Currency>}
      </Value>
    </Card>
  )
}
